import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {SwaggerUrl} from "../../models/swagger-url";
import Helpers from "../../utils/helpers";

@Injectable()
export class SwaggerControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getAllUrls(): Observable<SwaggerUrl[]> {
    return this.http.get(this.baseUrl + "swagger_url") as Observable<SwaggerUrl[]>;
  }

  public addUrl(swaggerUrl: SwaggerUrl) {
    Helpers.trimRecursiveObj(swaggerUrl);
    return this.http.post(this.baseUrl + "swagger_url", swaggerUrl);
  }

  public updateUrl(swaggerUrl: SwaggerUrl) {
    Helpers.trimRecursiveObj(swaggerUrl);
    const body = JSON.stringify(swaggerUrl);
    return this.http.put(this.baseUrl + "swagger_url", body);
  }

  public removeUrl(url: string) {
    return this.http.delete(this.baseUrl + "swagger_url/" + url, {responseType: "text"});
  }
}
